import React from "react"

// Components
import * as styles from "./index.module.scss"
import { QuoteLarge } from "../icons"

const Quote = ({ data: { author, remarks, quoteLogo }, smallLogo }) => (
  <div className={`${styles.quoteContainer} mt-9 py-5 lg:py-0 px-4 xl:px-0`}>
    <div
      className={`max-w-5xl mx-auto flex flex-col lg:flex-row items-center gap-x-20 gap-y-4`}
    >
      <div>
        <QuoteLarge
          className={`${styles.quoteIcon} ${smallLogo && styles.smallIcon}`}
        />
      </div>
      <div className="flex-1">
        <blockquote
          className={`${styles.blockquote} mb-3 text-center lg:text-left`}
        >
          {remarks.remarks}
        </blockquote>
        <div className="flex flex-col lg:flex-row lg:justify-between">
          {author && (
            <p className="mb-3 lg:mb-0 text-center lg:text-left">{author}</p>
          )}
          {quoteLogo && (
            <img
              src={quoteLogo?.file?.url}
              alt={quoteLogo?.title}
              className={`${styles.quoteImage} w-1/2 md:w-4/12`}
            />
          )}
        </div>
      </div>
    </div>
  </div>
)

export default Quote
